var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_recharge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_48",
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "airtel-icons/recharge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 162553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 326",
    d: "M6.95444 13.1667C7.78811 9.49269 11.0738 6.75 15 6.75C18.9263 6.75 22.2119 9.49269 23.0456 13.1667M6.95444 16.8333C7.78811 20.5073 11.0738 23.25 15 23.25C18.9262 23.25 22.2119 20.5073 23.0456 16.8333",
    stroke: "#39294F",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.31195 18.9819L7.05009 16.3983L9.63373 18.1364",
    stroke: "#39294F",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.8773 11.8652L23.1269 14.4313L20.5608 12.6809",
    stroke: "#39294F",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 162866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.0626 12.0667L12.938 12.0667L14.207 12.0667C16.3553 12.0667 16.4647 15.7061 13.6251 15.7061L12.938 15.7061L15.8986 18.6667",
    stroke: "#FE6867",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9374 13.653L17.0622 13.653",
    stroke: "#FE6867",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillHistoryIcon);
export default __webpack_public_path__ + "static/media/bill_history_icon.5860a7155ee5f9c31afe51b746d9c045.svg";
export { ForwardRef as ReactComponent };